import { Alert, Button, Snackbar } from '@mui/material';
import React from 'react';
import { useAuthContext } from 'contexts/auth-context';
import styles from './impersonation.module.scss';

export const ImpersonationBanner = () => {
  const { user } = useAuthContext();

  // Render the user-impersonation banner whenever localStorage carries
  // an `impersonate_user` key. We show it even when the backend hasn't
  // confirmed (auth-context's `impersonatedUser` not yet populated) —
  // that case usually means the new endpoint isn't deployed yet, and
  // an always-on banner gives the operator immediate feedback that the
  // header IS being sent and an EXIT control to recover from any state.
  const localImpersonateUser = typeof window !== 'undefined'
    ? window.localStorage.getItem('impersonate_user')
    : null;
  const acknowledged = !!user?.impersonatedUser;
  if (localImpersonateUser) {
    const exitUserImpersonation = () => {
      window.localStorage.removeItem('impersonate_user');
      window.location.reload();
    };
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open
      >
        <Alert
          className={styles.impersonation_banner}
          severity="warning"
          variant="filled"
          icon={false}
          action={(
            <Button variant="contained" size="small" onClick={exitUserImpersonation}>
              EXIT
            </Button>
          )}
        >
          {'Borrowing role bundle of '}
          <b>{user?.impersonatedUser ?? localImpersonateUser}</b>
          {acknowledged
            ? ' (prod) — your identity, their roles.'
            : ' — header sent but backend hasn\u2019t acknowledged. Deploy may be pending.'}
        </Alert>
      </Snackbar>
    );
  }

  if (!user) return undefined;

  if (!user.impersonatedRoles) return undefined;

  const unimpersonate = () => {
    window.localStorage.removeItem('impersonation');
    window.location.reload();
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open
    >
      <Alert
        className={styles.impersonation_banner}
        severity="info"
        variant="filled"
        icon={false}
        action={(
          <Button variant="contained" size="small" onClick={unimpersonate}>
            EXIT
          </Button>
        )}
      >
        {'You are currently impersonating '}
        <b>{user.impersonatedRoles.join(', ')}</b>
      </Alert>
    </Snackbar>
  );
};
